<template>
  <div>
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="linkResident"
      title="VINCULAR RESIDENTE"
      :size="isNotCustomerHasResident.length == 0 ? 'md' : 'lg'"
    >
      <div
        class="v-clean p-5 text-center"
        v-if="isNotCustomerHasResident.length == 0"
      >
        <h6 class="text-center upper-text worksansr">Sem resultados!!!</h6>
      </div>
      <h6 v-if="isNotCustomerHasResident.length > 0">PESQUISAR:</h6>
      <v-text-field
        v-if="isNotCustomerHasResident.length > 0"
        v-model="search"
        append-icon="mdi-magnify"
        label="Digite sua pesquisa"
        single-line
        hide-details
        class="mb-4"
      />
      <v-data-table
        v-show="isNotCustomerHasResident.length > 0"
        dense
        :headers="[
          { text: 'NOME', value: 'name' },
          { text: 'GÊNERO', value: 'gender_name' },
          { text: 'IDADE', value: 'date_of_birth' },
        ]"
        :items="isNotCustomerHasResident"
        :search="search"
        :footer-props="{
          'items-per-page-options': [10, 25, 100],
          'items-per-page-text': 'Mostrar',
        }"
        @click:row="createCustomerHasResident"
      >
        <template v-slot:[`item.date_of_birth`]="{ item }">
          <td>
            <span
              v-b-tooltip.html
              :title="`Data de nascimento <br /> ${formatDate(
                item.date_of_birth,
                false
              )}`"
              >{{ getAge(item.date_of_birth) }} anos</span
            >
          </td>
        </template>
      </v-data-table>
    </b-modal>
    <b-overlay :show="loadingCustomerHasResident" opacity="0.99">
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 pb-0 col-12 d-flex align-items-center"
        >
          <h6 class="mb-0">RESIDENTES VINCULADOS</h6>
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center justify-content-end"
        >
          <v-btn class="btn-add mb-1" @click="$bvModal.show('linkResident')">
            <i class="fas fa-plus mr-2 text-twenty"></i> VINCULAR
          </v-btn>
        </div>
      </div>
      <hr v-show="isCustomerHasResident.length > 0" />
      <div
        class="v-clean p-5 text-center"
        v-show="isCustomerHasResident.length == 0"
      >
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <v-list-item v-for="(item, key) in isCustomerHasResident" :key="key">
        <v-list-item-content class="p-0">
          <v-list-item-subtitle class="m-0">
            <div class="row">
              <div class="col-xl-5 xol-lg-5 col-md-6 col-sm-12 col-12">
                <h6 class="line-break">
                  NOME: <span class="worksansr">{{ item.resident_name }}</span>
                </h6>
                <h6 class="line-break">
                  DATA DE NASCIMENTO:<span class="worksansr">
                    {{ formatDate(item.date_of_birth, false) }} -
                    {{ getAge(item.date_of_birth) }} ANOS
                  </span>
                </h6>
                <h6 class="line-break">
                  GÊNERO: <span class="worksansr">{{ item.gender_name }}</span>
                </h6>
              </div>
              <div
                class="row col-xl-4 xol-lg-4 col-md-4 col-sm-12 col-12 d-flex align-items-center"
              >
                <div>
                  <h6
                    :for="`responsible_for_payment_${item.resident_id}`"
                    class="pl-3 mt-2 line-break"
                  >
                    RESPONSÁVEL PELO PAGAMENTO?
                  </h6>
                  <input
                    :id="`responsible_for_payment_${item.resident_id}`"
                    type="checkbox"
                    :checked="item.responsible_for_payment"
                    :ref="`responsible_for_payment_${item.resident_id}`"
                    @click="handleChangeResponsibleForPayment(item)"
                    class="ml-5"
                  />
                </div>
              </div>
              <div
                class="col-xl-3 xol-lg-3 col-md-2 col-sm-12 col-12 d-flex justify-content-end align-items-center"
              >
                <ConfirmationDialog
                  :disabled="loadingCustomerHasResident"
                  :loading="loadingCustomerHasResident"
                  headerClass="modal-header-red"
                  message-title="REMOVER?"
                  message-body="Deseja realmente remover vinculo do residente com familiar?"
                  open-class="btn-delete"
                  open-left-icon="fa-times"
                  openText="EXCLUIR"
                  @yes="deleteCustomerHasResident(item.resident_id)"
                />
              </div>
            </div>
            <hr />
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </b-overlay>
  </div>
</template>

<script>
import ConfirmationDialog from "../Components/ConfirmationDialog";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import { formatDate } from "../../lib/format";

import { getAge } from "../../lib/getAgeByDate";

export default {
  name: "CustomerHasResident",

  components: {
    ConfirmationDialog,
  },

  props: {
    customer_id: [String, Number],
  },

  data() {
    return {
      errors: [],
      search: "",
      residents: [],
      loadingCustomerHasResident: false,
      isCustomerHasResident: [],
      isNotCustomerHasResident: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    formatDate,

    async retrieve() {
      if (this.errors.length == 0) await this.getResidentHasCustomer();
      if (this.errors.length == 0) await this.getNotCustomerHasResident();
    },

    async getResidentHasCustomer() {
      try {
        this.loadingCustomerHasResident = true;

        const { customer_id } = this;

        const response = await api.get("/rest-home/residents/by-customer", {
          params: { customer_id },
        });

        const { error, errors, customerHasResident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.isCustomerHasResident = customerHasResident;
        }

        this.loadingCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getNotCustomerHasResident() {
      try {
        const { customer_id } = this;

        let params = { customer_id };

        const response = await api.get(
          "/rest-home/residents/unrelated-residents",
          {
            params,
          }
        );

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.isNotCustomerHasResident = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async createCustomerHasResident({ resident_id }) {
      try {
        this.loadingCustomerHasResident = true;

        const { customer_id } = this;

        let params = { customer_id, resident_id };

        const response = await api.post(
          "/rest-home/customer/bind-resident",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getResidentHasCustomer();
          this.getNotCustomerHasResident();
          this.$bvModal.hide("linkResident");
        } else {
          toast(message, "error");
        }

        this.loadingCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteCustomerHasResident(resident_id) {
      try {
        this.loadingCustomerHasResident = true;

        const { customer_id } = this;

        let data = { customer_id, resident_id };

        const response = await api.delete(
          "/rest-home/customer/unbind-resident",
          {
            data,
          }
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getResidentHasCustomer();
          this.getNotCustomerHasResident();
        } else {
          toast(message, "error");
        }

        this.loadingCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeResponsibleForPayment(item) {
      try {
        const { customer_id } = this;
        const { resident_id } = item;

        var responsible_for_payment =
          this.$refs[`responsible_for_payment_${resident_id}`][0].checked;

        let params = { resident_id, customer_id, responsible_for_payment };

        const response = await api.post(
          "/rest-home/customer/responsible-for-payment/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getResidentHasCustomer();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeGuarantor(item) {
      try {
        const { customer_id } = this;
        const { resident_id } = item;

        var guarantor = this.$refs[`guarantor_${resident_id}`][0].checked;

        let params = { resident_id, customer_id, guarantor };

        const response = await api.post(
          "/rest-home/customer/guarantor/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getResidentHasCustomer();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.line-break {
  white-space: normal;
}
</style>